if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.productId = this.dataset.productId;
        this.form = this.querySelector("form");
        this.form.querySelector('[name="id"]').disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.cartDrawer = document.querySelector("cart-drawer");
        this.submitButton = this.querySelector('[type="submit"]');
        this.buyNowButton = this.querySelector("[data-fast-checkout]");
        this.checkoutInput = this.querySelector(
          'input[name="return_to"][value="/checkout"]',
        );
        this.addonsContainer = document.querySelector("[multistep-addon-form]");
        this.booksAddOnContainer = document.querySelector(
          "[product-addon-form]",
        );

        if (this.buyNowButton) {
          this.buyNowButton.addEventListener("click", (event) => {
            // In POS mode the buy-now path would bypass the kiosk
            // intercept (form.submit() doesn't fire submit listeners),
            // sending the customer straight to Shopify checkout. Route
            // it through the regular submit flow so the POS branch in
            // onSubmitHandler runs and we redirect to /pages/pos-shipping.
            if (window.isPOS()) {
              event.preventDefault();
              this.form.requestSubmit();
              return;
            }
            this.buyNowButton.setAttribute("aria-disabled", true);
            this.buyNowButton.classList.add("is-loading");
            this.checkoutInput &&
              this.checkoutInput.removeAttribute("disabled");
            // form.submit() fires no submit listener, so addItemToCart never
            // runs here and cannot carry the cover across.
            this.syncCoverImageUrl();
            this.form.submit();
          });
        }
      }

      onSubmitHandler(event) {
        if (!this.cartDrawer && !window.isPOS()) return;
        event.preventDefault();
        if (this.submitButton.classList.contains("is-loading")) return;

        this.handleErrorMessage();
        if (this.cartDrawer) {
          this.cartDrawer.setActiveElement(document.activeElement);
        }
        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("is-loading");

        if (
          document.querySelector("script#original-newspapers") &&
          !window.isPOS()
        ) {
          // Only run these checks for original-newspapers. POS sessions
          // skip them entirely: the kiosk flow never touches the Shopify
          // cart, so cart-state validations against stale terminal state
          // are not just unnecessary, they can wrongly reject a sale.
          this.customCartChecks()
            .then(() => {
              const fetchedData = this.addItemToCart();
              this.handleFetchedData(fetchedData);
              fetchedData.then(() => {
                this.customCartChecksAfter();
              });
            })
            .catch(() => {
              // Validation failed, do nothing (error already shown)
            });
        } else {
          const fetchedData = this.addItemToCart();
          // POS mode redirects inside addItemToCart and never resolves
          // the promise — calling handleFetchedData would leave its
          // Promise.all pending and the submit button stuck loading
          // if navigation is blocked or slow.
          if (!window.isPOS()) {
            this.handleFetchedData(fetchedData);
          }
        }
      }

      customCartChecks() {
        return new Promise((resolve, reject) => {
          const formData = new FormData(this.form);
          const stockQty = Number(
            formData.get("properties[Newspaper Quantity]"),
          );
          const newMediaCode = formData.get("properties[Media Code]");
          const newNewspaperDate = formData.get("properties[Newspaper Date]");

          if (!stockQty || isNaN(stockQty) || stockQty <= 0) {
            console.log(
              "DEBUG: product-form: Original Newspapers custom checks: No valid Newspaper Quantity.",
            );
            this.customUILogger(
              "debug",
              "product-form: Original Newspapers custom checks: No valid Newspaper Quantity.",
              { newMediaCode, newNewspaperDate, stockQty },
            );
            this.handleErrorMessage("No valid Newspaper Quantity.");
            this.resetSubmitButtonState();
            reject("No valid Newspaper Quantity.");
            return;
          } else {
            const newCustomisationLocale = formData.get(
              "properties[customisation.locale]",
            );
            const newNewspaperTitle = formData.get(
              "properties[Newspaper Title]",
            );
            const newNewspaperOrigin = formData.get(
              "properties[Newspaper Origin]",
            );
            const newHNNewspaperPrice = Number(
              formData.get("properties[HN Newspaper Price]"),
            );
            const giftboxInput = document.querySelector("#addonId-giftbox");
            const alcoholInput = document.querySelector("#addonId-alcohol");
            const addonVariantIdsInput =
              document.getElementById("addonVariantIds");
            console.log(
              "DEBUG: product-form: customCartChecks",
              giftboxInput,
              alcoholInput,
              addonVariantIdsInput,
              {
                newCustomisationLocale,
                newMediaCode,
                newNewspaperDate,
                newNewspaperTitle,
                newNewspaperOrigin,
                newHNNewspaperPrice,
                stockQty,
              },
            );
          }

          fetch("/cart.js")
            .then((res) => res.json())
            .then((cart) => {
              const originalNewspapersInCart = cart.items.filter(
                (item) => item.handle === "original-newspapers",
              );
              let matchedCartQty = 0;
              originalNewspapersInCart.forEach((item) => {
                if (
                  item.properties &&
                  item.properties["Newspaper Quantity"] &&
                  item.properties["Media Code"] === newMediaCode &&
                  item.properties["Newspaper Date"] === newNewspaperDate
                ) {
                  matchedCartQty += 1;
                }
              });
              if (matchedCartQty >= stockQty) {
                this.customUILogger(
                  "debug",
                  "product-form: Original Newspapers custom checks: Max number of matching newspapers in cart, newMediaCode:" +
                    newMediaCode +
                    ", newNewspaperDate:" +
                    newNewspaperDate +
                    ", matchedCartQty:" +
                    matchedCartQty +
                    ", stockQty:" +
                    stockQty,
                );
                this.customUILogger(
                  "debug",
                  "product-form: Original Newspapers custom checks: ",
                  {
                    originalNewspapersInCart: originalNewspapersInCart.map(
                      (item) => ({
                        properties: item.properties,
                        quantity: item.quantity,
                      }),
                    ),
                  },
                );
                console.log(
                  "DEBUG: product-form: Original Newspapers custom checks: Max number of matching newspapers in cart, matchedCartQty:" +
                    matchedCartQty +
                    ", stockQty:" +
                    stockQty,
                );
                this.handleErrorMessage(
                  "Max number of matching newspapers in cart.",
                );
                this.resetSubmitButtonState();
                reject("Max number of matching newspapers in cart.");
                return;
              }
              resolve();
            })
            .catch((error) => {
              console.error(
                "ERROR: product-form: Original Newspapers custom checks: Cart fetch failed:",
                error,
              );
              this.customUILogger(
                "error",
                "product-form: Original Newspapers custom checks: Cart fetch failed:",
                error,
              );
            });
        });
      }

      customCartChecksAfter() {
        return new Promise((resolve) => {
          const formData = new FormData(this.form);
          const newNewspaperQuantity = Number(
            formData.get("properties[Newspaper Quantity]"),
          );
          const newMediaCode = formData.get("properties[Media Code]");
          const newNewspaperDate = formData.get("properties[Newspaper Date]");
          const newCustomisationLocale = formData.get(
            "properties[customisation.locale]",
          );
          const newNewspaperTitle = formData.get("properties[Newspaper Title]");
          const newNewspaperOrigin = formData.get(
            "properties[Newspaper Origin]",
          );
          const newHNNewspaperPrice = Number(
            formData.get("properties[HN Newspaper Price]"),
          );
          const addonVariantIdInputs =
            document.getElementById("addonVariantIds");
          const hiddenAddonIdInputs = Array.from(
            document.querySelectorAll(
              'input[type="hidden"][name="properties[_addon_id]"]',
            ),
          );
          const radios = document.querySelectorAll(
            'input[type="radio"][name^="properties[addon.giftbox]"], input[type="radio"][name^="properties[addon.alcohol]"]',
          );
          const radioOptions = Array.from(radios).map((radio) => ({
            id: radio.id,
            name: radio.name,
            value: radio.value,
            variantId: radio.dataset.variantId,
            checked: radio.checked,
          }));
          const giftboxInputObj = radioOptions.find(
            (radio) => radio.name.includes("addon.giftbox") && radio.checked,
          );
          const alcoholInputObj = radioOptions.find(
            (radio) => radio.name.includes("addon.alcohol") && radio.checked,
          );
          let logMsg =
            "product-form: customCartChecksAfter giftboxInputObj, alcoholInputObj:";
          let logMeta = { giftboxInputObj, alcoholInputObj };
          console.log("DEBUG:", logMsg, logMeta);
          this.customUILogger("debug", logMsg, logMeta);
          const hiddenAddonIdsObj = hiddenAddonIdInputs.map((hidden) => ({
            id: hidden.id,
            name: hidden.name,
            value: hidden.value,
            variantId: hidden.dataset.variantId,
          }));
          logMsg = "product-form: customCartChecksAfter hiddenAddonIdsObj:";
          logMeta = { hiddenAddonIdsObj };
          console.log("DEBUG:", logMsg, logMeta);
          this.customUILogger("debug", logMsg, logMeta);
          const newspaperFormObj = {
            newNewspaperQuantity,
            newMediaCode,
            newNewspaperDate,
            newCustomisationLocale,
            newNewspaperTitle,
            newNewspaperOrigin,
            newHNNewspaperPrice,
          };
          logMsg = "product-form: customCartChecksAfter newspaperFormObj:";
          logMeta = { newspaperFormObj };
          console.log("DEBUG:", logMsg, logMeta);
          this.customUILogger("debug", logMsg, logMeta);
          const addonVariantIdsInputObj =
            addonVariantIdInputs && addonVariantIdInputs.value
              ? {
                  addons: (() => {
                    try {
                      return JSON.parse(addonVariantIdInputs.value).map(
                        (addon) => ({
                          title: addon.value,
                          price: addon.price,
                          variantId: addon.variantId,
                        }),
                      );
                    } catch {
                      return [];
                    }
                  })(),
                }
              : null;
          logMsg =
            "product-form: customCartChecksAfter addonVariantIdsInputObj:";
          logMeta = { addonVariantIdsInputObj };
          console.log("DEBUG:", logMsg, logMeta);
          this.customUILogger("debug", logMsg, logMeta);
          function mergeAddons(
            giftboxInputObj,
            alcoholInputObj,
            hiddenAddonIdsObj,
            addonVariantIdsInputObj,
          ) {
            const merged = [];
            function getOrCreate(addonId, variantId) {
              let entry = merged.find((a) => a.variantId === variantId);
              if (!entry) {
                entry = { addonId, variantId };
                merged.push(entry);
              }
              return entry;
            }
            if (giftboxInputObj) {
              const entry = getOrCreate(
                giftboxInputObj.value || giftboxInputObj.addonId,
                giftboxInputObj.variantId,
              );
              entry.id = giftboxInputObj.id;
              entry.source = "giftboxInputObj";
            }
            if (alcoholInputObj) {
              const entry = getOrCreate(
                alcoholInputObj.value || alcoholInputObj.addonId,
                alcoholInputObj.variantId,
              );
              entry.id = alcoholInputObj.id;
              entry.source = "alcoholInputObj";
            }
            if (Array.isArray(hiddenAddonIdsObj)) {
              hiddenAddonIdsObj
                .filter(
                  (hidden) =>
                    (giftboxInputObj &&
                      hidden.variantId === giftboxInputObj.variantId) ||
                    (alcoholInputObj &&
                      hidden.variantId === alcoholInputObj.variantId),
                )
                .forEach((hidden) => {
                  const entry = getOrCreate(
                    hidden.value || hidden.addonId,
                    hidden.variantId,
                  );
                  entry.id = hidden.id;
                  entry.source = "hiddenAddonIdsObj";
                });
            }
            if (
              addonVariantIdsInputObj &&
              Array.isArray(addonVariantIdsInputObj.addons)
            ) {
              addonVariantIdsInputObj.addons.forEach((addon) => {
                // Try to find the hidden input for this variantId
                const giftboxInput = document.querySelector(
                  "#addonId-giftbox-" + addon.variantId,
                );
                const alcoholInput = document.querySelector(
                  "#addonId-alcohol-" + addon.variantId,
                );
                let addonId = null;
                if (giftboxInput && giftboxInput.value) {
                  addonId = giftboxInput.value;
                } else if (alcoholInput && alcoholInput.value) {
                  addonId = alcoholInput.value;
                }
                const entry = getOrCreate(addonId, addon.variantId);
                entry.title = addon.title;
                entry.price = addon.price;
                entry.source = "addonVariantIdsInputObj";
              });
            }
            return merged;
          }
          const mergedFormAddons = mergeAddons(
            giftboxInputObj,
            alcoholInputObj,
            hiddenAddonIdsObj,
            addonVariantIdsInputObj,
          );
          logMsg =
            "product-form: customCartChecksAfter mergedFormAddons, newspaperFormObj:";
          logMeta = { mergedFormAddons, newspaperFormObj };
          console.log("DEBUG:", logMsg, logMeta);
          this.customUILogger("debug", logMsg, logMeta);
          fetch("/cart.js")
            .then((res) => res.json())
            .then((cart) => {
              // Create array of item objects for logging
              // More efficient and cleaner to use .map() to build cartItems in one step after filtering, rather than pushing inside a .forEach.
              const cartItems =
                Array.isArray(cart.items) && cart.items.length > 0
                  ? cart.items.map((item) => ({
                      addon_id: item.properties?._addon_id ?? null,
                      handle: item.handle ?? null,
                      title: item.title ?? null,
                      product_type: item.product_type ?? null,
                      sku: item.sku ?? null,
                      id: item.id ?? null,
                      properties: {
                        "customisation.locale":
                          item.properties?.["customisation.locale"] ?? null,
                        "Media Code": item.properties?.["Media Code"] ?? null,
                        "Newspaper Date":
                          item.properties?.["Newspaper Date"] ?? null,
                        "Newspaper Title":
                          item.properties?.["Newspaper Title"] ?? null,
                        "Newspaper Origin":
                          item.properties?.["Newspaper Origin"] ?? null,
                        "HN Newspaper Price":
                          item.properties?.["HN Newspaper Price"] ?? null,
                        "Newspaper Quantity":
                          item.properties?.["Newspaper Quantity"] ?? null,
                        "addon.alcohol":
                          item.properties?.["addon.alcohol"] ?? null,
                        "addon.giftbox":
                          item.properties?.["addon.giftbox"] ?? null,
                        _addon_id: item.properties?.["_addon_id"] ?? null,
                        _main_id: item.properties?.["_main_id"] ?? null,
                      },
                    }))
                  : [];
              // Group by addon_id
              const cartItemsByAddonId = {};
              const addonIdOrder = [];
              cartItems.forEach((item) => {
                const key = item.addon_id || "no_addon_id";
                if (!cartItemsByAddonId[key]) {
                  cartItemsByAddonId[key] = [];
                  addonIdOrder.push(key);
                }
                cartItemsByAddonId[key].push(item);
              });
              logMsg =
                "product-form: customCartChecksAfter addonIdOrder, cartItemsByAddonId:";
              logMeta = { addonIdOrder, cartItemsByAddonId };
              console.log("DEBUG:", logMsg, logMeta);
              this.customUILogger("debug", logMsg, logMeta);
              // Compare newspaperFormObj and cartItems by newspaper fields
              const newspaperMatches = cartItems.filter((cartItem) => {
                const props = cartItem.properties || {};
                return (
                  String(props["Media Code"]) ===
                    String(newspaperFormObj.newMediaCode) &&
                  String(props["Newspaper Date"]) ===
                    String(newspaperFormObj.newNewspaperDate) &&
                  String(props["Newspaper Title"]) ===
                    String(newspaperFormObj.newNewspaperTitle) &&
                  String(props["Newspaper Origin"]) ===
                    String(newspaperFormObj.newNewspaperOrigin) &&
                  String(props["HN Newspaper Price"]) ===
                    String(newspaperFormObj.newHNNewspaperPrice) &&
                  String(props["Newspaper Quantity"]) ===
                    String(newspaperFormObj.newNewspaperQuantity)
                );
              });
              // Get the latest addon_id from addonIdOrder
              const latestAddonId =
                addonIdOrder.length > 0 ? addonIdOrder[0] : null;
              logMsg =
                "product-form: customCartChecksAfter latestAddonId, newspaperMatches:";
              logMeta = { latestAddonId, newspaperMatches };
              console.log("DEBUG:", logMsg, logMeta);
              this.customUILogger("debug", logMsg, logMeta);
              // Filter newspaperMatches to only those with the latest AddonId
              const filteredNewspaperMatches = latestAddonId
                ? newspaperMatches.filter(
                    (match) => match.addon_id === latestAddonId,
                  )
                : [];
              const newspaperMatch =
                filteredNewspaperMatches.length > 0
                  ? filteredNewspaperMatches[0]
                  : null;
              const cartMatch = !!newspaperMatch;
              let logLevel = cartMatch ? "debug" : "error";
              logMsg = `product-form: customCartChecksAfter: Newspaper consistency: ${cartMatch}`;
              logMeta = cartMatch
                ? {
                    id: newspaperMatch.id,
                    _addon_id: newspaperMatch.properties._addon_id,
                    cartMatch,
                  }
                : {
                    newspaperFormObj,
                    cartMatch,
                    cartItemsByAddonId: cartItemsByAddonId,
                  };
              this.customUILogger(logLevel, logMsg, logMeta);
              console[cartMatch ? "log" : "error"](
                `${cartMatch ? "DEBUG" : "ERROR"}: product-form: customCartChecksAfter: Newspaper consistency: ${cartMatch}`,
                logMeta,
              );
              // Compare mergedFormAddons and cartItems by variantId
              if (
                newspaperMatch &&
                newspaperMatch.properties &&
                newspaperMatch.properties._addon_id
              ) {
                const targetAddonId = newspaperMatch.properties._addon_id;
                mergedFormAddons.forEach((formAddon) => {
                  const match = cartItems.find(
                    (cartItem) =>
                      cartItem.addon_id === targetAddonId &&
                      String(formAddon.variantId) === String(cartItem.id),
                  );
                  let cartMatch = !!match;
                  let logLevel = cartMatch ? "debug" : "error";
                  let logMsg = `product-form: customCartChecksAfter: Addon consistency: ${cartMatch}`;
                  let logMeta = cartMatch
                    ? { formAddon, cartMatch, cartItem: match }
                    : {
                        formAddon,
                        cartMatch,
                        cartItemsByAddonId: cartItemsByAddonId,
                      };
                  this.customUILogger(logLevel, logMsg, logMeta);
                  console[cartMatch ? "log" : "error"](
                    `${cartMatch ? "DEBUG" : "ERROR"}: product-form: customCartChecksAfter: Addon consistency: ${cartMatch}`,
                    logMeta,
                  );
                });
              }
              resolve();
            })
            .catch((error) => {
              console.error(
                "ERROR: product-form: Original Newspapers custom checks: Cart fetch failed:",
                error,
              );
              this.customUILogger(
                "error",
                "product-form: Original Newspapers custom checks: Cart fetch failed:",
                error,
              );
            });
        });
      }

      async customUILogger(level, message, meta = {}) {
        // Dispatch a custom event for logging, handled by a custom element
        const logEvent = new CustomEvent("custom-uilogger", {
          detail: { level, message, meta },
          bubbles: true,
          composed: true,
        });
        window.dispatchEvent(logEvent);
      }

      selectedVariantIsFoil(variantId) {
        // The source of truth for the foil upgrade is the resolved variant,
        // not the independent cover_design / cover_finish radios, which can
        // desync from it (HIS001R-29). The lookup is scoped to this form's
        // section first: product cards (search, recommendations,
        // recently-viewed) also render <product-selector>, so the first one
        // in the document is not guaranteed to belong to the main product.
        if (!variantId) {
          return false;
        }
        try {
          const section = this.closest(".shopify-section");
          const selector =
            (section && section.querySelector("product-selector")) ||
            document.querySelector("product-selector");
          if (!selector || typeof selector.getVariantData !== "function") {
            return false;
          }
          const variants = selector.getVariantData();
          const selectedVariant = variants.find(
            (variant) => String(variant.id) === String(variantId),
          );
          const optionValues =
            selectedVariant && Array.isArray(selectedVariant.options)
              ? selectedVariant.options
              : [];
          return optionValues.some((option) => {
            if (typeof option !== "string") {
              return false;
            }
            const normalized = option.toLowerCase();
            // Negated values ('No Foil', 'Without Foil') must not count as
            // the upgrade.
            return (
              normalized.includes("foil") &&
              !/(^|[^a-z])(no|non|not|without)[\s-]+foil/.test(normalized)
            );
          });
        } catch (error) {
          window.console.warn("[Foil] variant lookup failed", error);
          return false;
        }
      }

      addItemToCart() {
        return new Promise((resolve, reject) => {
          const submissionId = window.submissionId;
          const config = fetchConfig("javascript");
          config.headers["X-Requested-With"] = "XMLHttpRequest";
          delete config.headers["Content-Type"];
          // Read the cover at submit time, not on change: the reveal is
          // debounced and, on one template, deferred by a timeout.
          this.syncCoverImageUrl();
          const formData = new FormData(this.form);
          const fieldsToDefault = [
            "properties[customisation.name]",
            "properties[customisation.surname]",
            "properties[customisation.inscription]",
          ];

          fieldsToDefault.forEach((fieldName) => {
            const value = formData.get(fieldName);
            if (value !== null && value.trim() === "") {
              formData.set(fieldName, " ");
            }
          });
          if (submissionId) {
            formData.append("properties[_addon_id]", submissionId);
          }
          if (submissionId) {
            formData.append("properties[_main_id]", submissionId);
          }
          if (this.cartDrawer) {
            // `sections` tells /cart/add to return pre-rendered cart-drawer
            // HTML. POS sessions skip /cart/add entirely (see the
            // window.isPOS() branch below), and on kiosk pages without a
            // drawer rendered this.cartDrawer is null — guarding the
            // dereference is what lets the POS path reach its redirect.
            formData.append(
              "sections",
              this.cartDrawer
                .getSectionsToRender()
                .map((section) => section.id),
            );
          }
          formData.append("sections_url", window.location.pathname);

          if (this.addonsContainer) {
            const addonVariantIdsInput =
              this.addonsContainer.querySelector("#addonVariantIds");
            if (addonVariantIdsInput && addonVariantIdsInput.value) {
              const addonVariants = JSON.parse(addonVariantIdsInput.value);
              // const isSecondStepDisabled = this.addonsContainer.querySelector('#alcohol-addon-disabled-message:not(.hidden)') !== null;
              const isSecondStepDisabledInput =
                this.addonsContainer.querySelector("[data-alcohol-disabled]");
              let isSecondStepDisabled;
              if (isSecondStepDisabledInput) {
                isSecondStepDisabled = isSecondStepDisabledInput.getAttribute(
                  "data-alcohol-disabled",
                );
              }
              addonVariants.forEach((addon, index) => {
                if (addon.variantId) {
                  if (
                    index === 0 ||
                    index === 1 ||
                    isSecondStepDisabled === "false"
                  ) {
                    formData.append(`items[${index}][id]`, addon.variantId);
                    formData.append(`items[${index}][quantity]`, 1);
                    formData.append(
                      `items[${index}][properties][_addon_id]`,
                      submissionId || "",
                    );
                  }
                }
              });
            }
          }
          if (this.booksAddOnContainer) {
            const _booksAddOnNewNodeContainer = document.querySelector(
              "[product-addon-form]",
            );
            // Check this.booksAddOnContainer still linked to old container node
            if (
              _booksAddOnNewNodeContainer &&
              _booksAddOnNewNodeContainer !== this.booksAddOnContainer
            ) {
              // Re-select the container after AJAX completes
              this.booksAddOnContainer = document.querySelector(
                "[product-addon-form]",
              );
            }
            const addOnCheckboxes = this.booksAddOnContainer.querySelectorAll(
              'input[name^="properties"]',
            );

            let checkedIndex = 0;
            addOnCheckboxes.forEach((addon) => {
              if (addon.checked) {
                // --- Property Handling Block ---
                // If the checkbox has a property name, add it to formData as a property.
                if (addon.value.trim().length > 0) {
                  const propertyName = this.replaceAddonWithCustomisation(
                    addon.name,
                  );
                  formData.append(propertyName, "true");
                }

                // --- Item Creation Block ---
                // If the checkbox has a value and a variantId, create a new item entry in formData.
                if (addon.value.trim().length > 0 && addon.dataset?.variantId) {
                  formData.append(
                    `items[${checkedIndex}][id]`,
                    addon.dataset.variantId,
                  );
                  formData.append(`items[${checkedIndex}][quantity]`, 1);
                  formData.append(
                    `items[${checkedIndex}][properties][_addon_id]`,
                    submissionId || "",
                  );

                  checkedIndex++;
                }
              }
            });
          }
          // Handle pictorial covers
          const pictorialCoverValue = formData.get(
            "properties[customisation.pictorial_cover]",
          );
          if (pictorialCoverValue === "With picture") {
            formData.set("properties[customisation.pictorial_cover]", "true");
          } else if (pictorialCoverValue === "Without picture") {
            formData.set("properties[customisation.pictorial_cover]", "false");
          }

          // Handle Cover design -- Luxury Foil Cover option's value
          const selectedCoverDesign =
            formData.get("Cover Design") ||
            formData.get("Cover design") ||
            formData.get("cover design");
          if (
            typeof selectedCoverDesign === "string" &&
            selectedCoverDesign.trim().toLowerCase() === "luxury foil cover"
          ) {
            formData.set(
              "properties[customisation.cover_design]",
              "newsstand-foil",
            );
          }

          // Combine cover_design and cover_finish
          const existingCoverDesign = formData.get(
            "properties[customisation.cover_design]",
          );
          const coverFinish = formData.get(
            "properties[customisation.cover_finish]",
          );
          const isDateBooksTemplate = document.body.classList.contains(
            "template--date-books-2-0",
          );

          const normalizedCoverDesign =
            typeof existingCoverDesign === "string"
              ? existingCoverDesign.trim().toLowerCase()
              : "";
          const normalizedCoverFinish =
            typeof coverFinish === "string"
              ? coverFinish.trim().toLowerCase()
              : "";
          if (
            normalizedCoverFinish !== "" &&
            normalizedCoverFinish !== "standard"
          ) {
            if (
              isDateBooksTemplate &&
              normalizedCoverDesign === "newsstand" &&
              normalizedCoverFinish === "foil"
            ) {
              formData.set(
                "properties[customisation.cover_design]",
                "milestone-foil",
              );
            } else {
              const combinedCoverDesign = [
                normalizedCoverDesign,
                normalizedCoverFinish,
              ]
                .filter(Boolean)
                .join("-");
              if (combinedCoverDesign) {
                formData.set(
                  "properties[customisation.cover_design]",
                  combinedCoverDesign,
                );
              }
            }
          } else if (
            !isDateBooksTemplate &&
            normalizedCoverDesign &&
            !normalizedCoverDesign.endsWith("-foil") &&
            this.selectedVariantIsFoil(formData.get("id"))
          ) {
            // date-books-2.0 is governed entirely by the milestone-foil rule
            // above, so this generic suffix only applies elsewhere.
            // No usable cover_finish property drove the combine above, but the
            // resolved variant is a foil one. Products that model the foil
            // upgrade as a variant option (e.g. sports books: "Luxury Foil")
            // have no cover_finish property, so without this the order ships
            // a standard cover_design (e.g. plain "newsstand") while the
            // customer paid for foil, the HIS001R-29 defect. Derive the
            // suffix from the variant, the true record of what was purchased.
            formData.set(
              "properties[customisation.cover_design]",
              `${normalizedCoverDesign}-foil`,
            );
          }

          config.body = this.sanitizeFormData(formData);

          if (window.isPOS()) {
            // Extract from the sanitized FormData so the POS payload matches
            // exactly what would have been sent to /cart/add — empty-string
            // properties dropped, defaulted fields preserved.
            const items = this.extractPOSItems(config.body);
            sessionStorage.setItem(
              "pos_pending_order",
              JSON.stringify({ items }),
            );
            // Drop any idempotency key left over from a previous order
            // attempt. The shipping page generates a fresh one for the
            // new pending order — without this clear, a customer who
            // backed out and personalised a different order would have
            // the new submission deduped against the old order on the
            // backend.
            sessionStorage.removeItem("pos_idempotency_key");
            // Preserve the active locale prefix (e.g. /en-gb) so the redirect
            // doesn't drop the customer into the default-locale shipping page.
            const localeMatch = window.location.pathname.match(
              /^\/([a-z]{2}-[a-z]{2})\//,
            );
            const localePrefix = localeMatch ? `/${localeMatch[1]}` : "";
            window.location.href = `${localePrefix}/pages/pos-shipping`;
            return;
          }

          fetch(`${routes.cart_add_url}`, config)
            .then((response) => response.json())
            .then((response) => {
              if (response) {
                resolve(response);
                return;
              }
              this.resetSubmitButtonState();
              reject(response);
            })
            .catch((error) => {
              window.console.error(error);
            });
        });
      }

      // Build POS-shaped item list from the fully-transformed formData.
      // Main product is index 0; addons (added via items[N][...] in addItemToCart)
      // follow. _addon_id and _main_id properties are preserved verbatim.
      extractPOSItems(formData) {
        const items = [];

        const mainProperties = {};
        for (const [key, value] of formData.entries()) {
          if (key.startsWith("properties[") && key.endsWith("]")) {
            mainProperties[key.slice(11, -1)] = value;
          }
        }
        items.push({
          variantId: formData.get("id"),
          quantity: parseInt(formData.get("quantity") ?? "1", 10) || 1,
          properties: mainProperties,
        });

        let i = 0;
        while (formData.get(`items[${i}][id]`)) {
          const addonProps = {};
          for (const [key, value] of formData.entries()) {
            const match = key.match(/^items\[(\d+)\]\[properties\]\[(.+)\]$/);
            if (match && parseInt(match[1], 10) === i) {
              addonProps[match[2]] = value;
            }
          }
          items.push({
            variantId: formData.get(`items[${i}][id]`),
            quantity:
              parseInt(formData.get(`items[${i}][quantity]`) ?? "1", 10) || 1,
            properties: addonProps,
          });
          i++;
        }

        return items;
      }

      // Omit empty string values from form data before submitting the payload.
      sanitizeFormData(formData) {
        const cleanedFormData = new FormData();

        Array.from(formData.entries()).forEach(([key, value]) => {
          if (typeof value === "string" && value.trim() === "") {
            return;
          }

          cleanedFormData.append(key, value);
        });
        return cleanedFormData;
      }

      // The order confirmation email has to show the cover the customer chose,
      // not the PDP shot. Notification Liquid cannot resolve the metaobjects
      // behind custom.associated_images, so the already-resolved URL travels on
      // the line item as a private property instead.
      resolveCoverImageUrl() {
        // Archive newspapers belong to original-newspapers.js: the chosen front
        // page comes from the warehouse API and is never rendered on this PDP,
        // so the galleries below would hand back the generic product shot.
        if (document.querySelector("script#original-newspapers")) return "";

        const configuratorItems = document.querySelectorAll(
          "pdp-product-media .pdp_header__cover-img-item",
        );
        let element = null;

        if (configuratorItems.length) {
          // pdp-product-selector.js reveals exactly one item by removing
          // .hidden. Before the first change event none are hidden, and the
          // consolidate-bday-mstone reveal is deferred, so fall back to the
          // first item — that is what is on screen in both of those cases.
          element =
            document.querySelector(
              "pdp-product-media .pdp_header__cover-img-item:not(.hidden)",
            ) || configuratorItems[0];
        } else {
          // Legacy gallery: product-media.js moves Splide instead of toggling
          // .hidden, so the selection is whichever slide is active.
          element = document.querySelector(
            "[data-main-product-slider] .splide__slide.is-active",
          );
        }

        if (!element || !this.coverMatchesSelection(element)) return "";

        const img = element.querySelector("img");
        if (!img) return "";
        // currentSrc is the srcset candidate actually painted but stays empty
        // until the image loads, so src is the fallback. Both properties give
        // an absolute URL even though the attribute is protocol-relative.
        return this.emailSizedImageUrl(img.currentSrc || img.src || "");
      }

      // What is on screen is not proof of what was chosen: when the media key
      // finds no match the theme silently reveals mediaItems[0], which looks
      // plausible and is wrong. Rebuilding the theme key here would duplicate
      // logic that already disagrees with the data, so instead check the two
      // segments that read back unambiguously — the key opens with the chosen
      // colour and, where the gallery keys carry one, closes with the format.
      coverMatchesSelection(element) {
        const normalise = (value) =>
          String(value || "")
            .toLowerCase()
            .replace(/\s+/g, "-");
        const key = normalise(element.getAttribute("data-media-id"));
        // A numeric id is ordinary product media, not a cover keyed by option,
        // so there is no customisation to record and line.image already covers it.
        if (!key || /^\d+$/.test(key)) return false;

        const colourVariable = document
          .querySelector(".colour-variable")
          ?.textContent?.trim();
        const colour = colourVariable
          ? document.querySelector(
              `input[name='properties[${colourVariable}]']:checked`,
            )?.value
          : null;
        if (colour && !key.startsWith(`${normalise(colour)}-`)) return false;

        const formatInputs = [
          ...document.querySelectorAll("input[data-name='format']"),
        ];
        const chosenFormat = formatInputs.find((input) => input.checked)?.value;
        if (!chosenFormat) return true;

        // Only judge the tail when it is a format at all: legacy keys stop at
        // the cover design and would otherwise always be rejected.
        const tail = key.split("-").pop();
        const tailIsFormat = formatInputs.some(
          (input) => normalise(input.value) === tail,
        );
        if (!tailIsFormat) return true;

        return tail === normalise(chosenFormat);
      }

      // Carry an email-sized render rather than the 1440px PDP one. URLs with
      // no width parameter are left alone.
      emailSizedImageUrl(url) {
        if (!url || !url.includes("width=")) return url;
        return url.replace(/([?&])width=\d+/, "$1width=600");
      }

      // Keeping the value on a hidden input rather than appending to one
      // payload means both submit paths carry it: the AJAX path picks it up
      // through new FormData(this.form), and Buy it now posts the form itself.
      syncCoverImageUrl() {
        const url = this.resolveCoverImageUrl();
        if (!url) return;

        let input = this.form.querySelector(
          'input[name="properties[_cover_image_url]"]',
        );
        if (!input) {
          input = document.createElement("input");
          input.type = "hidden";
          input.name = "properties[_cover_image_url]";
          this.form.appendChild(input);
        }
        input.value = url;
      }

      /**
       * Replaces occurrences of "addon" with "customisation" in the given property name.
       *
       * @param {string} propertyName - The property name to process.
       * @returns {string} The property name with "addon" replaced by "customisation", if present.
       */
      replaceAddonWithCustomisation(propertyName) {
        if (propertyName.toLowerCase().includes("addon")) {
          return propertyName.replace(/addon/gi, "customisation");
        }
        return propertyName;
      }

      resetSubmitButtonState() {
        this.submitButton.classList.remove("is-loading");
        this.submitButton.removeAttribute("aria-disabled");
      }

      handleFetchedData(promise) {
        Promise.all([promise])
          .then((values) => {
            if (values.length === 0) {
              return;
            }

            const fetchedData = values[0];

            if (fetchedData.status) {
              this.handleErrorMessage(fetchedData.description);
              return;
            }

            this.cartDrawer.handleAddedItem(fetchedData);

            const quickview = document.querySelector(
              `#Product-Quickview-${this.productId}`,
            );

            if (quickview) {
              quickview.hide();
            }
          })
          .catch((error) => {
            window.console.error(error);
          })
          .finally(() => {
            this.resetSubmitButtonState();
          });
      }

      handleErrorMessage(errorMessage = false) {
        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".main-product__form-error-message-wrapper");
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".main-product__form-error-message",
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    },
  );
}
